import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    draft: {
        name:   'Draft',
        value:  'draft',
    },
    sent: {
        name:   'Sent',
        value:  'sent',
    },
    outstanding: {
        name:   'Outstanding',
        value:  'outstanding',
    },
    paid: {
        name:   'Paid',
        value:  'paid',
    },
}

const InvoiceDataTable = (props) => {
    const {
        customerId,
    } = props;

    const dataTableRef          = useRef(null);
    const [search, setSearch]   = useState("");
    const [filter, setFilter]   = useState(FILTER_OPTIONS.all.value);

    const renderRowButton = (invoice) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!invoice.can && invoice.can.view === true && (
                        <a className="text-primary cursor-pointer" href={route('job.order.invoice.edit', {
                            job:        invoice.job_id,
                            order:      invoice.order_id,
                            invoice:    invoice.id,
                        })}>
                            View
                        </a>
                    )}
                </div>
            </td>
        );
    }

    const fieldsToExclude = [
        'id',
        'deleted_at',
        'created_at',
        'order_id',
        'job_id',
        'can',
    ];

    if (customerId) {
        fieldsToExclude.push('customer_name');
    }

    return (
        <React.Fragment>
            <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                    <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                        <Filter
                            label={"Status:"}
                            value={filter}
                            options={Object.values(FILTER_OPTIONS)}
                            name={"filter_status"}
                            onChange={(value) => setFilter(value)}
                            classes={""}
                        />
                    </div>
                </div>
                <div className="col-12 col-xl-4 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                    <SearchInput
                        value={search}
                        classes={""}
                        placeholder={"Search..."}
                        onChange={(value) => setSearch(value)}
                    />
                </div>
            </div>
            <div className={"row m-0 p-0"}>
                <div className={"col-12 m-0 p-0"}>
                    <div className="data-table">
                        <AjaxDynamicDataTable
                            apiUrl={route('web-api.invoice.data-table').toString()}
                            loadingComponent={<LoadingIndicator />}
                            noDataComponent={<EmptyTable itemName="invoices" />}
                            fieldsToExclude={fieldsToExclude}
                            alwaysShowPagination
                            fieldMap={{
                                reference:          "Invoice Ref",
                                customer_name:      "Customer",
                                amount_excl_vat:    "Value Excl VAT (£)",
                                amount_incl_vat:    "Value Incl VAT (£)",
                                sent_at:            "Date Sent",
                                payment_due_at:     "Due Date",
                            }}
                            fieldOrder={[
                                'reference',
                                'customer_name',
                                'amount_excl_vat',
                                'amount_incl_vat',
                                'payment_due_at',
                                'sent_at',
                                'status',
                            ]}
                            ref={dataTableRef}
                            defaultOrderByField="reference"
                            defaultOrderByDirection="desc"
                            params={{
                                searchTerm:     search,
                                filterStatus:   filter,
                                customerId,
                            }}
                            buttons={(row) => renderRowButton(row)}
                            dataItemManipulator={(field, value, row) => {
                                switch (field) {
                                    case 'status':
                                        if (value === "Outstanding") {
                                            return (
                                                <span className={"text-danger font-weight-bold"}>{value}</span>
                                            );
                                        } else if (value === "Paid") {
                                            return (
                                                <span className={"text-success font-weight-bold"}>{value}</span>
                                            );
                                        }

                                        return (
                                            <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                        );
                                }

                                return <span>{value}</span>;
                            }}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default InvoiceDataTable;

const target = document.getElementById('invoices-datatable');
if (target) {
    ReactDOM.render(<InvoiceDataTable />, target);
}
